import { Language } from '../types';

export const translations: Record<Language, any> = {
  fr: {
    nav: {
      home: 'Accueil',
      about: 'Le Cabinet & Expert',
      services: 'Pôles d\'Expertise',
      training: 'Formations & Calendrier',
      verify: 'Vérifier un Certificat',
      faq: 'FAQ & Processus',
      contact: 'Contact & Devis',
      admin: 'Espace Admin',
      themeLight: 'Mode Clair',
      themeDark: 'Mode Sombre',
    },
    hero: {
      badge: 'Cabinet International de Conseil, Audit & Certification',
      titleHighlight: 'L\'Excellence Opérationnelle',
      titleEnd: 'au service de votre Performance',
      subtitle: 'Accompagnement stratégique, certification ISO, audit de conformité, sécurité maritime & HSE, et formations certifiantes d\'élite sous la direction de l\'Expert International Chérif Haddad.',
      ctaVerify: 'Vérifier un Certificat',
      ctaServices: 'Nos Domaines d\'Expertise',
      ctaContact: 'Demander un Audit / Devis',
      stats: {
        experience: '+18 Ans d\'Expertise',
        certified: '+1,500 Professionnels Certifiés',
        satisfaction: '99.4% Taux de Satisfaction',
        missions: '+85 Missions Internationales',
      },
    },
    about: {
      badge: 'Expertise & Leadership',
      title: 'Chérif Haddad Consulting & Expertise',
      founderTitle: 'Fondateur & Lead Auditor International',
      quote: '« La conformité n\'est pas une contrainte, mais le levier le plus puissant pour bâtir une organisation résiliente, compétitive et souveraine. »',
      p1: 'Le cabinet Chérif Haddad Consulting & Expertise est dirigé par un formateur et consultant international en activité depuis 2013, ancien Directeur IT et partenaire officiel de TNV Group en Algérie depuis 2024.',
      p2: 'Certifié ISO 19011 et fort d\'une longue expérience en ingénierie de solutions informatiques complexes et technologiques, l\'expert agit en tant qu\'accompagnateur stratégique et certificateur international pour propulser votre entreprise vers l\'excellence.',
      credentials: [
        'Formateur et Consultant International (depuis 2013)',
        'Ancien Directeur IT - Ingénierie de Solutions Complexes',
        'Partenaire Officiel TNV Group en Algérie (depuis 2024)',
        'Auditeur & Certificateur International (ISO 19011)',
      ],
      valuesTitle: 'Nos Valeurs Fondamentales',
      values: [
        { title: 'Intégrité & Rigueur', desc: 'Une déontologie sans compromis dans tous nos audits et évaluations de conformité.' },
        { title: 'Excellence Méthodologique', desc: 'Des outils éprouvés pour des résultats mesurables et durables.' },
        { title: 'Sécurité & Confidentialité', desc: 'Protection stricte de vos données stratégiques et traçabilité inviolable.' },
      ],
    },
    services: {
      badge: 'Pôles de Compétences',
      title: 'Nos Domaines d\'Intervention Stratégique',
      subtitle: 'Une gamme complète de solutions d\'audit, de conseil et d\'accompagnement adaptée aux enjeux actuels de compétitivité et de gouvernance.',
      readMore: 'En savoir plus',
      requestQuote: 'Demander une intervention',
    },
    training: {
      badge: 'Développement des Compétences',
      title: 'Formations Qualifiantes & Certifiantes',
      subtitle: 'Programmes intensifs conçus pour les cadres, auditeurs, ingénieurs et responsables QHSE. Délivrance de certificats officiels infalsifiables.',
      filterAll: 'Tous les domaines',
      filterIso: 'Normes ISO & Qualité',
      filterHse: 'HSE & Sécurité Industrielle',
      filterMaritime: 'Maritime & Portuaire',
      filterAudit: 'Audit & Gouvernance',
      duration: 'Durée',
      format: 'Format',
      level: 'Niveau',
      nextSession: 'Prochaine session',
      registerBtn: 'S\'inscrire / Demander les tarifs',
      modalTitle: 'Demande d\'inscription à la formation',
    },
    verify: {
      badge: 'Vérification Officielle Sécurisée',
      title: 'Authentification Numérique des Certificats',
      subtitle: 'Vérifiez en temps réel l\'authenticité d\'un certificat délivré par Chérif Haddad Consulting & Expertise via son identifiant unique crypté ou en scannant son QR Code.',
      inputPlaceholder: 'Entrez le numéro du certificat',
      searchBtn: 'Vérifier l\'Authenticité',
      scanQrBtn: 'Scanner un QR Code',
      demoCertificates: 'Certificats de démonstration pour test direct :',
      validBadge: 'Certificat Authentifié & Valide',
      revokedBadge: 'Certificat Révoqué',
      expiredBadge: 'Certificat Expiré',
      notFoundTitle: 'Certificat Introuvable ou Invalide',
      notFoundDesc: 'Aucun certificat officiel correspondant à cet identifiant n\'a été trouvé dans notre registre cryptographique sécurisé. Veuillez vérifier la saisie ou contacter notre service vérification.',
      certDetails: 'Détails du Titulaire & de la Certification',
      recipientName: 'Nom du Récipiendaire',
      company: 'Entreprise / Organisme',
      course: 'Intitulé de la Certification',
      standard: 'Référentiel / Norme',
      issueDate: 'Date de Délivrance',
      expiryDate: 'Date d\'Expiration',
      grade: 'Mention / Évaluation',
      status: 'Statut du Document',
      issuer: 'Organisme Émetteur',
      hash: 'Empreinte Cryptographique (SHA-256)',
      downloadBtn: 'Télécharger le Certificat Officiel (PDF / Imprimer)',
      viewOriginal: 'Afficher le Document Officiel',
      secureNote: 'Ce registre utilise un système de signature cryptographique garantissant l\'inviolabilité des mentions et des compétences certifiées.',
    },
    contact: {
      badge: 'Prenez Contact',
      title: 'Parlons de Vos Projets & Besoins',
      subtitle: 'Nos experts vous répondent sous 24h ouvrées pour toute demande d\'audit, de formation ou d\'accompagnement.',
      form: {
        fullName: 'Nom & Prénom',
        email: 'Adresse Email Professionnelle',
        phone: 'Numéro de Téléphone',
        company: 'Société / Organisation',
        serviceType: 'Service concerné',
        message: 'Détaillez votre besoin ou projet...',
        submit: 'Envoyer ma Demande de Devis',
        successTitle: 'Demande Transmise avec Succès !',
        successMsg: 'Notre équipe et l\'expert Chérif Haddad analyseront votre demande et vous recontacteront sous 24h.',
      },
      offices: {
        title: 'Bureaux & Réseau International',
        paris: 'Paris, France — Europe Head Office',
        algiers: 'Alger, Algérie — Maghreb Office',
        tunis: 'Tunis, Tunisie — North Africa Hub',
        dubai: 'Dubai, EAU — Middle East Coordination',
      },
    },
    faq: {
      badge: 'Foire Aux Questions & Méthodologies',
      title: 'Questions Fréquentes sur Nos Interventions',
      subtitle: 'Comprendre en toute clarté nos processus de conseil, le déroulement des audits, le cycle de certification ISO et l\'authentification cryptographique de nos diplômes.',
      searchPlaceholder: 'Rechercher une question, norme ou mot-clé (ex: ISO 9001, audit à blanc, QR code, durée)...',
      categories: {
        all: 'Toutes les Questions',
        consulting: 'Conseil & Accompagnement',
        audit: 'Audit & Conformité',
        certification: 'Certification & Normes ISO',
        verification: 'Vérification & QR Code',
        training: 'Formations & Qualification',
      },
      expandAll: 'Tout Développer',
      collapseAll: 'Tout Réduire',
      noResults: 'Aucune question ne correspond à votre recherche.',
      resetSearch: 'Réinitialiser la recherche',
      popularBadge: 'Essentiel',
      ctaTitle: 'Vous avez une question spécifique ou un projet sur-mesure ?',
      ctaSubtitle: 'Nos consultants seniors et Lead Auditors vous répondent sous 24h ouvrées pour analyser vos besoins et cadrer votre intervention.',
      ctaButton: 'Demander un Devis / Échange avec un Expert',
      ctaVerify: 'Vérifier un Certificat en Ligne',
    },
    admin: {
      title: 'Espace Administrateur Sécurisé',
      subtitle: 'Gestion cryptographique et délivrance des certificats officiels',
      loginTitle: 'Accès Réservé - Authentification',
      loginSubtitle: 'Veuillez saisir vos identifiants administrateur pour accéder à la console de gestion.',
      passwordPlaceholder: 'Code d\'accès administrateur',
      loginBtn: 'Se Connecter à la Console',
      demoLoginBtn: 'Connexion Rapide Démo (Admin)',
      logoutBtn: 'Déconnexion',
      stats: {
        totalCerts: 'Certificats Émis',
        activeCerts: 'Certificats Actifs',
        revokedCerts: 'Certificats Révoqués',
        totalVerifications: 'Vérifications Effectuées',
      },
      tabs: {
        manage: 'Gestion des Certificats',
        create: 'Émettre un Nouveau Certificat',
        logs: 'Journal des Vérifications',
        backup: 'Sauvegarde & Sécurité',
        profile: 'Mon Profil & Sécurité',
      },
      profile: {
        title: 'Profil de l\'Administrateur & Paramètres de Sécurité',
        subtitle: 'Gérez vos coordonnées officielles, votre adresse email, vos titres d\'audit et vos accès sécurisés.',
        personalSection: 'Informations Personnelles & Signataire Officiel',
        name: 'Nom complet de l\'Administrateur *',
        email: 'Adresse Email Professionnelle *',
        phone: 'Numéro de Téléphone Direct',
        role: 'Fonction / Statut',
        organization: 'Organisation / Cabinet',
        leadAuditorTitle: 'Titre & Signature Lead Auditor (figurant sur les certificats) *',
        saveProfileBtn: 'Enregistrer les Informations du Profil',
        profileSuccess: 'Profil et coordonnées mis à jour avec succès !',
        securitySection: 'Sécurité du Compte & Changement de Mot de Passe',
        currentPassword: 'Mot de passe ou Code PIN actuel *',
        newPassword: 'Nouveau mot de passe ou Code PIN (min. 4 caractères) *',
        confirmPassword: 'Confirmer le nouveau mot de passe *',
        updatePasswordBtn: 'Mettre à Jour le Mot de Passe',
        passwordSuccess: 'Mot de passe administrateur modifié avec succès !',
        passwordMismatch: 'Les deux nouveaux mots de passe ne correspondent pas.',
        passwordTooShort: 'Le mot de passe doit comporter au moins 4 caractères.',
        invalidCurrentPassword: 'Le mot de passe actuel saisi est incorrect.',
        securityTips: 'Pour des raisons de sécurité, utilisez un code robuste combinant lettres, chiffres et caractères spéciaux.',
        preferencesSection: 'Préférences d\'Audit & Notifications',
        notifyOnVerify: 'Recevoir une notification email à chaque vérification de certificat',
        twoFactor: 'Activer la double authentification (2FA) pour la console',
        lastUpdated: 'Dernière mise à jour du profil',
        subtabs: {
          profile: 'Profil & Sécurité',
          header: 'En-tête & Logo (Header)',
          footer: 'Pied de page (Footer)',
          branding: 'Thème & Couleurs',
        },
        branding: {
          title: 'Personnalisation de la Marque, de l\'En-tête et du Pied de page',
          subtitle: 'Téléversez votre logo personnalisé, modifiez le slogan, les informations de contact, les mentions de copyright et les teintes d\'accent.',
          logoSection: 'Logo du Site & Identité Visuelle',
          uploadLogo: 'Téléverser un Logo (PNG, JPG, SVG, WebP)',
          uploadLogoBtn: 'Parcourir les fichiers...',
          logoPreview: 'Aperçu du Logo',
          useDefaultLogo: 'Utiliser l\'Emblème Vectoriel Officiel par Défaut',
          logoUrlOrBase64: 'Ou coller l\'URL de l\'image',
          companyName: 'Nom de l\'Entreprise / Cabinet *',
          headerTagline: 'Slogan Principal (Header)',
          headerSubtitle: 'Sous-titre des Expertises (Header)',
          topBannerSection: 'Bannière Supérieure d\'Annonce (Top Bar)',
          showTopBanner: 'Afficher la bannière supérieure informative',
          topBannerText: 'Texte de la bannière supérieure',
          citiesList: 'Villes & Implantation (ex: Paris • Alger • Tunis • Dubai)',
          headerPhone: 'Téléphone de Contact Officiel',
          headerEmail: 'Email de Contact Officiel',
          footerSection: 'Pied de page (Footer) & Mentions Légales',
          footerCopyright: 'Texte de Copyright (supporte {year} pour l\'année automatique)',
          footerAboutText: 'Texte de présentation / À propos (Footer)',
          addressParis: 'Adresse Bureau Paris',
          addressAlger: 'Adresse Bureau Alger',
          addressDubai: 'Adresse Bureau Dubai / International',
          socialSection: 'Réseaux Sociaux Professionnels',
          socialLinkedin: 'Lien LinkedIn',
          socialTwitter: 'Lien Twitter / X',
          socialFacebook: 'Lien Facebook',
          accentColor: 'Couleur d\'Accentuation du Thème',
          saveBrandingBtn: 'Enregistrer les Modifications du Site',
          resetBrandingBtn: 'Réinitialiser aux Valeurs par Défaut',
          brandingSuccess: 'Paramètres du site (logo, header, footer, couleurs) enregistrés avec succès !',
          brandingResetSuccess: 'Paramètres du site réinitialisés aux valeurs d\'origine.',
        },
      },
      table: {
        id: 'Identifiant',
        recipient: 'Récipiendaire',
        course: 'Programme / Norme',
        issueDate: 'Date d\'Émission',
        status: 'Statut',
        actions: 'Actions',
      },
      createForm: {
        title: 'Formulaire d\'Émission de Certificat Numérique',
        recipientName: 'Nom complet du titulaire *',
        recipientEmail: 'Email du titulaire',
        recipientCompany: 'Entreprise / Institution',
        courseTitleFr: 'Titre de la formation (Français) *',
        courseTitleEn: 'Titre de la formation (Anglais)',
        courseTitleAr: 'Titre de la formation (Arabe)',
        standardCode: 'Code Norme / Référentiel (ex: ISO 9001:2015) *',
        category: 'Catégorie *',
        issueDate: 'Date de délivrance *',
        expiryDate: 'Date d\'expiration (optionnel)',
        grade: 'Mention / Note (ex: Félicitations du jury)',
        leadAuditor: 'Signataire / Lead Auditor',
        location: 'Lieu de délivrance',
        submitBtn: 'Générer & Signer Cryptographiquement le Certificat',
        successMsg: 'Certificat généré avec succès ! Le QR code et l\'empreinte SHA-256 ont été créés.',
      },
      logsTitle: 'Journal d\'Audit des Vérifications en Temps Réel',
      backupTitle: 'Gestion des Données & Export Crypté',
      exportBtn: 'Exporter la Base des Certificats (JSON Crypté)',
      importBtn: 'Restaurer une Sauvegarde',
      resetBtn: 'Réinitialiser aux Données Initiales',
    },
    footer: {
      tagline: 'Cabinet International d\'Audit, de Conseil, de Formation QHSE & de Certification d\'Entreprises.',
      quickLinks: 'Navigation Rapide',
      servicesTitle: 'Nos Expertises',
      legalTitle: 'Sécurité & Conformité',
      copyright: 'Tous droits réservés. Système de vérification certifié conforme.',
      confidentiality: 'Politique de Confidentialité',
      terms: 'Mentions Légales',
      isoStatement: 'Processus d\'évaluation et de certification alignés sur les directives ISO/IEC 17024 & ISO/IEC 17021.',
    },
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About & Expert',
      services: 'Expertise Areas',
      training: 'Training & Schedule',
      verify: 'Verify Certificate',
      faq: 'FAQ & Process',
      contact: 'Contact & Quote',
      admin: 'Admin Portal',
      themeLight: 'Light Mode',
      themeDark: 'Dark Mode',
    },
    hero: {
      badge: 'International Consulting, Audit & Certification Firm',
      titleHighlight: 'Operational Excellence',
      titleEnd: 'driving your Strategic Growth',
      subtitle: 'Strategic consulting, ISO certifications, compliance audits, maritime security & HSE, and elite certified training programs under the leadership of Senior International Expert Chérif Haddad.',
      ctaVerify: 'Verify a Certificate',
      ctaServices: 'Explore Our Expertise',
      ctaContact: 'Request an Audit / Quote',
      stats: {
        experience: '+18 Years Experience',
        certified: '+1,500 Certified Professionals',
        satisfaction: '99.4% Satisfaction Rate',
        missions: '+85 Global Missions',
      },
    },
    about: {
      badge: 'Expertise & Leadership',
      title: 'Chérif Haddad Consulting & Expertise',
      founderTitle: 'Founder & Senior International Lead Auditor',
      quote: '“Compliance is not a constraint, but the most powerful catalyst to build a resilient, competitive, and sovereign organization.”',
      p1: 'Chérif Haddad Consulting & Expertise is led by an international trainer and consultant active since 2013, a former IT Director, and the official partner of TNV Group in Algeria since 2024.',
      p2: 'ISO 19011 certified and backed by extensive experience in engineering complex IT and technological solutions, the expert acts as an international strategic guide and certifier to drive your company towards operational excellence.',
      credentials: [
        'International Trainer and Consultant (since 2013)',
        'Former IT Director - Complex Solutions Engineering',
        'Official TNV Group Partner in Algeria (since 2024)',
        'ISO 19011 Certified International Auditor & Certifier',
      ],
      valuesTitle: 'Our Core Values',
      values: [
        { title: 'Integrity & Rigor', desc: 'Uncompromising ethics in all our audits and compliance assessments.' },
        { title: 'Methodological Excellence', desc: 'Proven frameworks delivering tangible, measurable, and lasting results.' },
        { title: 'Security & Trust', desc: 'Strict protection of your strategic data and tamper-proof digital credentials.' },
      ],
    },
    services: {
      badge: 'Core Competencies',
      title: 'Our Strategic Service Lines',
      subtitle: 'A full suite of auditing, consulting, and certification services aligned with modern governance and market standards.',
      readMore: 'Learn more',
      requestQuote: 'Request an intervention',
    },
    training: {
      badge: 'Skill Development',
      title: 'Certified & Executive Training Courses',
      subtitle: 'High-impact programs engineered for executives, auditors, engineers, and QHSE officers. Issuance of tamper-proof digital certificates.',
      filterAll: 'All Domains',
      filterIso: 'ISO Standards & Quality',
      filterHse: 'HSE & Industrial Safety',
      filterMaritime: 'Maritime & Ports',
      filterAudit: 'Audit & Governance',
      duration: 'Duration',
      format: 'Format',
      level: 'Level',
      nextSession: 'Next Session',
      registerBtn: 'Enroll / Inquire Rates',
      modalTitle: 'Course Registration Inquiry',
    },
    verify: {
      badge: 'Secure Official Verification',
      title: 'Digital Certificate Verification Engine',
      subtitle: 'Verify in real-time the authenticity of any credential issued by Chérif Haddad Consulting & Expertise by entering its unique encrypted ID or scanning its QR Code.',
      inputPlaceholder: 'Enter Certificate ID',
      searchBtn: 'Verify Authenticity',
      scanQrBtn: 'Scan QR Code',
      demoCertificates: 'Sample test certificates for instant verification:',
      validBadge: 'Official Validated Certificate',
      revokedBadge: 'Revoked Certificate',
      expiredBadge: 'Expired Certificate',
      notFoundTitle: 'Certificate Not Found or Invalid',
      notFoundDesc: 'No authentic certificate matching this unique ID was found in our secure cryptographic registry. Please double-check the ID or contact our verification team.',
      certDetails: 'Credential & Holder Details',
      recipientName: 'Recipient Full Name',
      company: 'Organization / Company',
      course: 'Certification Title',
      standard: 'Standard / Framework',
      issueDate: 'Issuance Date',
      expiryDate: 'Expiration Date',
      grade: 'Distinction / Evaluation',
      status: 'Document Status',
      issuer: 'Issuing Body',
      hash: 'Cryptographic Fingerprint (SHA-256)',
      downloadBtn: 'Download Official Certificate (PDF / Print)',
      viewOriginal: 'View Official Document',
      secureNote: 'This registry utilizes cryptographic signatures guaranteeing tamper-proof verification of all issued credentials.',
    },
    contact: {
      badge: 'Get In Touch',
      title: 'Let\'s Discuss Your Strategic Goals',
      subtitle: 'Our expert team responds within 24 business hours for any audit, consulting, or training inquiries.',
      form: {
        fullName: 'Full Name',
        email: 'Work Email Address',
        phone: 'Phone Number',
        company: 'Company / Organization',
        serviceType: 'Service of Interest',
        message: 'Tell us about your project or requirements...',
        submit: 'Send Quote Request',
        successTitle: 'Inquiry Successfully Sent!',
        successMsg: 'Our consulting team and Lead Auditor Chérif Haddad will review your request and contact you within 24 hours.',
      },
      offices: {
        title: 'Global Offices & Network',
        paris: 'Paris, France — Europe Head Office',
        algiers: 'Algiers, Algeria — Maghreb Office',
        tunis: 'Tunis, Tunisia — North Africa Hub',
        dubai: 'Dubai, UAE — Middle East Coordination',
      },
    },
    faq: {
      badge: 'Frequently Asked Questions',
      title: 'Common Inquiries on Our Processes & Auditing',
      subtitle: 'Clear insights into our strategic consulting workflows, auditing rigor, ISO certification lifecycles, and tamper-proof cryptographic verification.',
      searchPlaceholder: 'Search a question, standard or keyword (e.g. ISO 9001, mock audit, QR code, duration)...',
      categories: {
        all: 'All Questions',
        consulting: 'Consulting & Strategy',
        audit: 'Audit & Compliance',
        certification: 'ISO Standards & Certification',
        verification: 'Verification & QR Code',
        training: 'Training & Qualifications',
      },
      expandAll: 'Expand All',
      collapseAll: 'Collapse All',
      noResults: 'No questions matched your search criteria.',
      resetSearch: 'Reset search',
      popularBadge: 'Essential',
      ctaTitle: 'Do you have a specific question or custom organizational project?',
      ctaSubtitle: 'Our senior consultants and Lead Auditors are available to address your specific operational requirements within 24 hours.',
      ctaButton: 'Request a Custom Consultation / Quote',
      ctaVerify: 'Verify an Issued Certificate',
    },
    admin: {
      title: 'Secure Administrator Console',
      subtitle: 'Cryptographic registry and official certificate management',
      loginTitle: 'Restricted Access - Authentication',
      loginSubtitle: 'Please enter your administrator credentials to access the management portal.',
      passwordPlaceholder: 'Admin Security Code',
      loginBtn: 'Sign In to Console',
      demoLoginBtn: 'Quick Demo Login (Admin)',
      logoutBtn: 'Sign Out',
      stats: {
        totalCerts: 'Issued Certificates',
        activeCerts: 'Active Certificates',
        revokedCerts: 'Revoked Certificates',
        totalVerifications: 'Verification Logs',
      },
      tabs: {
        manage: 'Manage Certificates',
        create: 'Issue New Certificate',
        logs: 'Audit Logs',
        backup: 'Backup & Security',
        profile: 'My Profile & Security',
      },
      profile: {
        title: 'Administrator Profile & Security Settings',
        subtitle: 'Manage your contact details, email address, lead auditor titles, and security credentials.',
        personalSection: 'Personal Details & Official Signatory',
        name: 'Administrator Full Name *',
        email: 'Official Work Email Address *',
        phone: 'Direct Phone Number',
        role: 'Position / Status',
        organization: 'Organization / Firm',
        leadAuditorTitle: 'Lead Auditor Title & Signature (displayed on certificates) *',
        saveProfileBtn: 'Save Profile Details',
        profileSuccess: 'Profile and contact information updated successfully!',
        securitySection: 'Account Security & Change Password',
        currentPassword: 'Current Password or PIN *',
        newPassword: 'New Password or PIN (min. 4 characters) *',
        confirmPassword: 'Confirm New Password *',
        updatePasswordBtn: 'Update Password',
        passwordSuccess: 'Administrator password changed successfully!',
        passwordMismatch: 'The two new passwords do not match.',
        passwordTooShort: 'Password must be at least 4 characters long.',
        invalidCurrentPassword: 'The current password entered is incorrect.',
        securityTips: 'For optimal security, use a strong code combining letters, numbers, and symbols.',
        preferencesSection: 'Audit & Notification Preferences',
        notifyOnVerify: 'Receive email alerts on certificate verifications',
        twoFactor: 'Enable Two-Factor Authentication (2FA) for Console',
        lastUpdated: 'Profile last updated',
        subtabs: {
          profile: 'Profile & Security',
          header: 'Header & Logo',
          footer: 'Footer & Legal',
          branding: 'Theme & Colors',
        },
        branding: {
          title: 'Brand, Header & Footer Customization',
          subtitle: 'Upload custom logo, modify tagline, contact info, copyright text and theme color accents.',
          logoSection: 'Website Logo & Visual Identity',
          uploadLogo: 'Upload Logo (PNG, JPG, SVG, WebP)',
          uploadLogoBtn: 'Browse files...',
          logoPreview: 'Logo Preview',
          useDefaultLogo: 'Use Official Default Vector Emblem',
          logoUrlOrBase64: 'Or paste image URL',
          companyName: 'Company / Firm Name *',
          headerTagline: 'Main Header Tagline',
          headerSubtitle: 'Header Subtitle of Expertise',
          topBannerSection: 'Top Announcement Banner',
          showTopBanner: 'Show top informational banner',
          topBannerText: 'Top banner announcement text',
          citiesList: 'Offices & Cities (e.g. Paris • Alger • Tunis • Dubai)',
          headerPhone: 'Official Contact Phone',
          headerEmail: 'Official Contact Email',
          footerSection: 'Footer & Legal Information',
          footerCopyright: 'Copyright text (supports {year} for current year)',
          footerAboutText: 'About description blurb (Footer)',
          addressParis: 'Paris Office Address',
          addressAlger: 'Algiers Office Address',
          addressDubai: 'Dubai / International Office Address',
          socialSection: 'Professional Social Networks',
          socialLinkedin: 'LinkedIn Profile URL',
          socialTwitter: 'Twitter / X URL',
          socialFacebook: 'Facebook URL',
          accentColor: 'Theme Color Accent',
          saveBrandingBtn: 'Save Website Settings',
          resetBrandingBtn: 'Reset to Factory Defaults',
          brandingSuccess: 'Website branding settings saved successfully!',
          brandingResetSuccess: 'Website branding reset to original defaults.',
        },
      },
      table: {
        id: 'Certificate ID',
        recipient: 'Recipient',
        course: 'Program / Standard',
        issueDate: 'Issue Date',
        status: 'Status',
        actions: 'Actions',
      },
      createForm: {
        title: 'Digital Certificate Issuance Form',
        recipientName: 'Recipient Full Name *',
        recipientEmail: 'Recipient Email',
        recipientCompany: 'Company / Institution',
        courseTitleFr: 'Course Title (French) *',
        courseTitleEn: 'Course Title (English)',
        courseTitleAr: 'Course Title (Arabic)',
        standardCode: 'Standard Code (e.g. ISO 9001:2015) *',
        category: 'Category *',
        issueDate: 'Issue Date *',
        expiryDate: 'Expiry Date (optional)',
        grade: 'Distinction / Grade (e.g. Honors)',
        leadAuditor: 'Signatory / Lead Auditor',
        location: 'Issuance Location',
        submitBtn: 'Generate & Cryptographically Sign Certificate',
        successMsg: 'Certificate generated successfully! Dynamic QR code and SHA-256 fingerprint generated.',
      },
      logsTitle: 'Real-Time Verification Audit Logs',
      backupTitle: 'Data Management & Encrypted Backup',
      exportBtn: 'Export Certificate Database (Encrypted JSON)',
      importBtn: 'Restore from Backup',
      resetBtn: 'Reset to Sample Data',
    },
    footer: {
      tagline: 'International Firm for Audit, Consulting, QHSE Training & Corporate Certification.',
      quickLinks: 'Quick Navigation',
      servicesTitle: 'Our Expertise',
      legalTitle: 'Security & Compliance',
      copyright: 'All rights reserved. Certified tamper-proof verification system.',
      confidentiality: 'Privacy Policy',
      terms: 'Legal Terms',
      isoStatement: 'Evaluation and certification workflows aligned with ISO/IEC 17024 & ISO/IEC 17021 standards.',
    },
  },
  ar: {
    nav: {
      home: 'الرئيسية',
      about: 'المكتب والخبير',
      services: 'مجالات الخبرة',
      training: 'التدريب والروزنامة',
      verify: 'التحقق من شهادة',
      faq: 'الأسئلة الشائعة',
      contact: 'اتصل بنا وطلب عرض',
      admin: 'فضاء الإدارة',
      themeLight: 'الوضع النهاري',
      themeDark: 'الوضع الليلي',
    },
    hero: {
      badge: 'مكتب دولي للاستشارات والتدقيق والمطابقة وإصدار الشهادات',
      titleHighlight: 'التميز المؤسسي والعملياتي',
      titleEnd: 'في خدمة أدائكم الاستراتيجي',
      subtitle: 'مرافقة استراتيجية، شهادات المطابقة الدولية ISO، التدقيق والامتثال، السلامة البحرية والصناعية QHSE، وتدريب احترافي رفيع المستوى بإشراف الخبير الدولي شريف حداد.',
      ctaVerify: 'التحقق من صحة شهادة',
      ctaServices: 'استكشف مجالات خبرتنا',
      ctaContact: 'طلب تدقيق / عرض أسعار',
      stats: {
        experience: '+18 سنة من الخبرة الدولية',
        certified: '+1,500 إطار ومهني معتمد',
        satisfaction: '99.4% نسبة رضا العملاء',
        missions: '+85 مهمة دولية ناجحة',
      },
    },
    about: {
      badge: 'الخبرة والريادة',
      title: 'شريف حداد للاستشارات والخبرة',
      founderTitle: 'المؤسس ورئيس المدققين الدوليين المعتمدين',
      quote: '«الامتثال والمطابقة ليسا قيداً، بل هما أقوى رافعة لبناء مؤسسة قوية، ذات كفاءة تنافسية وسيادية.»',
      p1: 'يقود مكتب شريف حداد للاستشارات والخبرة مدرب ومستشار دولي نشط منذ عام 2013، شغل سابقاً منصب مدير تكنولوجيا المعلومات، وهو الشريك الرسمي لمجموعة TNV Group في الجزائر منذ عام 2024.',
      p2: 'حاصل على شهادة ISO 19011 كمدقق دولي ويتمتع بخبرة طويلة في هندسة الحلول المعلوماتية والتكنولوجية المعقدة. يعمل اليوم كمرشد استراتيجي ومانح شهادات دولي لدفع مؤسستكم نحو معايير التميز العالمية.',
      credentials: [
        'مدرب ومستشار دولي (منذ 2013)',
        'مدير سابق لتكنولوجيا المعلومات - هندسة الحلول المعقدة',
        'الشريك الرسمي لمجموعة TNV Group في الجزائر (منذ 2024)',
        'مدقق ومانح شهادات دولي معتمد (ISO 19011)',
      ],
      valuesTitle: 'قيمنا الجوهرية',
      values: [
        { title: 'النزاهة والصرامة', desc: 'أخلاقيات مهنية صارمة في جميع مهام التدقيق وتقييم المطابقة.' },
        { title: 'التميز المنهجي', desc: 'أدوات معتمدة دولياً لتحقيق نتائج ملموسة ومستدامة.' },
        { title: 'الأمان والسرية', desc: 'حماية كاملة لبياناتكم الاستراتيجية مع نظام توثيق رقمي غير قابل للتزوير.' },
      ],
    },
    services: {
      badge: 'مجالات التميز',
      title: 'محاور التدخل الاستراتيجي والخبرة',
      subtitle: 'مجموعة متكاملة من خدمات التدقيق، الاستشارات والمطابقة المصممة لتلبية تحديات التنافسية والحوكمة الحديثة.',
      readMore: 'المزيد من التفاصيل',
      requestQuote: 'طلب استشارة أو تدقيق',
    },
    training: {
      badge: 'تطوير الكفاءات',
      title: 'دورات تدريبية تأهيلية وشهادات مهنية',
      subtitle: 'برامج تدريبية مكثفة للمدراء، المدققين، المهندسين ومسؤولي الجودة والسلامة مع تسليم شهادات رسمية مؤمنة برمز الاستجابة السريعة.',
      filterAll: 'كافة المجالات',
      filterIso: 'معايير الآيزو والجودة',
      filterHse: 'الصحة والسلامة المهنية',
      filterMaritime: 'الموانئ والملاحة البحرية',
      filterAudit: 'التدقيق والحوكمة',
      duration: 'المدة',
      format: 'النمط',
      level: 'المستوى',
      nextSession: 'الدورة القادمة',
      registerBtn: 'التسجيل / طلب التسعيرة',
      modalTitle: 'طلب التسجيل في الدورة التدريبية',
    },
    verify: {
      badge: 'نظام التحقق الرسمي المشفّر',
      title: 'التحقق الرقمي الفوري من الشهادات',
      subtitle: 'تحقق في الوقت الفعلي من صحة وأصالة أي شهادة صادرة عن مكتب شريف حداد للاستشارات والخبرة بإدخال رقم الشهادة الفريد أو مسح رمز QR Code.',
      inputPlaceholder: 'أدخل رقم الشهادة',
      searchBtn: 'فحص صحة الشهادة',
      scanQrBtn: 'مسح رمز QR',
      demoCertificates: 'شهادات تجريبية للفحص الفوري المباشر:',
      validBadge: 'شهادة رسمية أصيلة وصالحة',
      revokedBadge: 'شهادة ملغاة',
      expiredBadge: 'شهادة منتهية الصلاحية',
      notFoundTitle: 'الشهادة غير موجودة أو الرقم غير صحيح',
      notFoundDesc: 'لم يتم العثور على أي سجل مطابق لهذا المعرف في قاعدة بيانات الشهادات المعتمدة. يرجى التأكد من الرمز المدخل أو التواصل مع إدارة التوثيق.',
      certDetails: 'تفاصيل حامل الشهادة والمؤهل المعتمد',
      recipientName: 'اسم المستفيد / المتدرب',
      company: 'المؤسسة / الهيئة',
      course: 'موضوع المؤهل / الدورة',
      standard: 'المعيار / المرجع الدولي',
      issueDate: 'تاريخ الإصدار',
      expiryDate: 'تاريخ الصلاحية',
      grade: 'التقدير / التقييم',
      status: 'حالة الوثيقة',
      issuer: 'الجهة المانحة',
      hash: 'البصمة الرقمية المشفرة (SHA-256)',
      downloadBtn: 'تحميل الشهادة الرسمية (PDF / طباعة)',
      viewOriginal: 'عرض الوثيقة الرسمية',
      secureNote: 'يعتمد هذا السجل على توقيع إلكتروني مشفر وبصمة رقمية تضمن عدم قابلية تعديل أو تزوير الشهادات الممنوحة.',
    },
    contact: {
      badge: 'تواصل معنا',
      title: 'لنناقش مشاريعكم واحتياجاتكم الاستراتيجية',
      subtitle: 'فريق خبرائنا جاهز للرد على استفساراتكم خلال 24 ساعة عمل لكافة خدمات التدقيق، الاستشارات والتأهيل.',
      form: {
        fullName: 'الاسم واللقب',
        email: 'البريد الإلكتروني المهني',
        phone: 'رقم الهاتف',
        company: 'اسم الشركة / المؤسسة',
        serviceType: 'الخدمة المطلوبة',
        message: 'تفاصيل المشروع أو الاحتياج التدريبي...',
        submit: 'إرسال طلب العرض',
        successTitle: 'تم إرسال طلبكم بنجاح!',
        successMsg: 'سيقوم فريق الخبراء ورئيس المدققين شريف حداد بدراسة طلبكم والتواصل معكم خلال 24 ساعة.',
      },
      offices: {
        title: 'المكاتب والشبكة الدولية',
        paris: 'باريس، فرنسا — المقر الأوروبي',
        algiers: 'الجزائر العاصمة — مكتب المغرب العربي',
        tunis: 'تونس العاصمة — مركز شمال إفريقيا',
        dubai: 'دبي، الإمارات — التنسيق الإقليمي للشرق الأوسط',
      },
    },
    faq: {
      badge: 'الأسئلة الشائعة والمنهجية',
      title: 'إجابات شاملة حول الاستشارات والتدقيق ومنح الشهادات',
      subtitle: 'كل ما تحتاج لمعرفته حول مراحل المرافقة الاستشارية، مسار التدقيق، معايير الآيزو، وبروتوكول التحقق المشفر من الشهادات.',
      searchPlaceholder: 'ابحث عن سؤال، معيار أو كلمة مفتاحية (مثال: ISO 9001، تدقيق تجريبي، رمز QR، المدة)...',
      categories: {
        all: 'كافة الأسئلة',
        consulting: 'الاستشارات والمرافقة',
        audit: 'التدقيق والامتثال',
        certification: 'شهادات الآيزو والمعايير',
        verification: 'التحقق ورمز QR',
        training: 'التدريب والتأهيل',
      },
      expandAll: 'توسيع الكل',
      collapseAll: 'طي الكل',
      noResults: 'لم يتم العثور على أي سؤال يطابق بحثكم.',
      resetSearch: 'إعادة ضبط البحث',
      popularBadge: 'سؤال أساسي',
      ctaTitle: 'هل لديكم استفسار خاص أو مشروع تأهيل لمؤسستكم؟',
      ctaSubtitle: 'فريق كبار الخبراء ورؤساء المدققين جاهزون للإجابة على استفساراتكم ومرافقتكم بدقة خلال 24 ساعة.',
      ctaButton: 'طلب استشارة مخصصة / عرض أسعار',
      ctaVerify: 'فحص صحة شهادة إلكترونياً',
    },
    admin: {
      title: 'لوحة التحكم الإدارية الآمنة',
      subtitle: 'الإدارة الرقمية والتوقيع المعتمد للشهادات الرسمية',
      loginTitle: 'منطقة محظورة - تسجيل الدخول',
      loginSubtitle: 'يرجى إدخال رمز الأمان الإداري للوصول إلى لوحة التحكم.',
      passwordPlaceholder: 'رمز الدخول الإداري',
      loginBtn: 'دخول للوحة التحكم',
      demoLoginBtn: 'دخول سريع تجريبي (Admin)',
      logoutBtn: 'تسجيل الخروج',
      stats: {
        totalCerts: 'إجمالي الشهادات الممنوحة',
        activeCerts: 'الشهادات السارية',
        revokedCerts: 'الشهادات الملغاة',
        totalVerifications: 'عمليات التحقق المسجلة',
      },
      tabs: {
        manage: 'إدارة الشهادات',
        create: 'إصدار شهادة جديدة',
        logs: 'سجل عمليات التحقق',
        backup: 'النسخ الاحتياطي والأمان',
        profile: 'الملف الشخصي والأمان',
      },
      profile: {
        title: 'الملف الشخصي للمسؤول وإعدادات الأمان',
        subtitle: 'إدارة بيانات الاتصال الرسمية، البريد الإلكتروني، ألقاب التدقيق والاعتماد، ورموز الأمان.',
        personalSection: 'البيانات الشخصية والموقع الرسمي',
        name: 'الاسم الكامل للمسؤول *',
        email: 'البريد الإلكتروني المهني الرسمي *',
        phone: 'رقم الهاتف المباشر',
        role: 'الصفة / الرتبة الإدارية',
        organization: 'المؤسسة / المكتب',
        leadAuditorTitle: 'لقب وتوقيع رئيس المدققين (الظاهر على الشهادات) *',
        saveProfileBtn: 'حفظ وتحديث بيانات الملف الشخصي',
        profileSuccess: 'تم تحديث الملف الشخصي وبيانات الاتصال بنجاح!',
        securitySection: 'أمان الحساب وتغيير كلمة المرور',
        currentPassword: 'كلمة المرور أو الرمز الحالي *',
        newPassword: 'كلمة المرور الجديدة أو الرمز (4 خانات على الأقل) *',
        confirmPassword: 'تأكيد كلمة المرور الجديدة *',
        updatePasswordBtn: 'تحديث كلمة المرور',
        passwordSuccess: 'تم تغيير كلمة المرور للمسؤول بنجاح!',
        passwordMismatch: 'كلمتا المرور الجديدتان غير متطابقتين.',
        passwordTooShort: 'يجب ألا تقل كلمة المرور عن 4 خانات.',
        invalidCurrentPassword: 'كلمة المرور الحالية المدخلة غير صحيحة.',
        securityTips: 'لأمان فائق، اختر رمزاً قوياً يجمع بين الحروف والأرقام والرموز الخاصة.',
        preferencesSection: 'تفضيلات التدقيق والإشعارات',
        notifyOnVerify: 'استلام إشعار بريدي عند كل عملية تحقق من صحة شهادة',
        twoFactor: 'تفعيل التحقق الثنائي (2FA) للوحة التحكم',
        lastUpdated: 'تاريخ آخر تحديث للملف الشخصي',
        subtabs: {
          profile: 'الملف الشخصي والأمان',
          header: 'الترويسة والشعار (Header)',
          footer: 'تذييل الصفحة (Footer)',
          branding: 'الهوية والألوان',
        },
        branding: {
          title: 'تخصيص الهوية البصرية، الترويسة وتذييل الموقع',
          subtitle: 'رفع الشعار المخصص، تعديل الشعار النصي، بيانات التواصل، حقوق النشر وألوان السمة.',
          logoSection: 'شعار الموقع والهوية البصرية',
          uploadLogo: 'رفع شعار مخصص (PNG, JPG, SVG, WebP)',
          uploadLogoBtn: 'اختيار ملف من الجهاز...',
          logoPreview: 'معاينة الشعار',
          useDefaultLogo: 'استخدام الشعار الرسمي الافتراضي',
          logoUrlOrBase64: 'أو إدخال رابط الصورة مباشرة',
          companyName: 'اسم الشركة / المكتب *',
          headerTagline: 'الشعار النصي الرئيسي (Header)',
          headerSubtitle: 'العنوان الفرعي للخدمات (Header)',
          topBannerSection: 'الشريط الإعلاني العلوي (Top Bar)',
          showTopBanner: 'إظهار الشريط الإعلاني العلوي',
          topBannerText: 'نص الشريط الإعلاني العلوي',
          citiesList: 'المدن والمقرات (مثال: Paris • Alger • Tunis • Dubai)',
          headerPhone: 'رقم هاتف الاتصال الرسمي',
          headerEmail: 'البريد الإلكتروني للاتصال الرسمي',
          footerSection: 'تذييل الصفحة (Footer) والمعلومات القانونية',
          footerCopyright: 'نص حقوق الملكية (يدعم {year} للسنة الحالية تلقائياً)',
          footerAboutText: 'نبذة عن المكتب (Footer)',
          addressParis: 'عنوان مقر باريس',
          addressAlger: 'عنوان مقر الجزائر',
          addressDubai: 'عنوان مقر دبي / الدولي',
          socialSection: 'شبكات التواصل المهني',
          socialLinkedin: 'رابط لينكد إن LinkedIn',
          socialTwitter: 'رابط تويتر / إكس X',
          socialFacebook: 'رابط فيسبوك Facebook',
          accentColor: 'لون التمييز البصري للسمة',
          saveBrandingBtn: 'حفظ إعدادات الموقع',
          resetBrandingBtn: 'إعادة الضبط للافتراضي',
          brandingSuccess: 'تم حفظ إعدادات الموقع والشعار بنجاح!',
          brandingResetSuccess: 'تمت إعادة ضبط إعدادات الموقع إلى القيم الأصلية.',
        },
      },
      table: {
        id: 'معرف الشهادة',
        recipient: 'المستفيد',
        course: 'البرنامج / المعيار',
        issueDate: 'تاريخ الإصدار',
        status: 'الحالة',
        actions: 'الإجراءات',
      },
      createForm: {
        title: 'نموذج إصدار شهادة رقمية مشفرة',
        recipientName: 'الاسم الكامل للمستفيد *',
        recipientEmail: 'البريد الإلكتروني',
        recipientCompany: 'المؤسسة / الشركة',
        courseTitleFr: 'عنوان الدورة (بالفرنسية) *',
        courseTitleEn: 'عنوان الدورة (بالإنجليزية)',
        courseTitleAr: 'عنوان الدورة (بالعربية)',
        standardCode: 'رمز المعيار (مثال: ISO 9001:2015) *',
        category: 'التصنيف *',
        issueDate: 'تاريخ الإصدار *',
        expiryDate: 'تاريخ الانتهاء (اختياري)',
        grade: 'التقدير (مثال: ممتاز مع مرتبة الشرف)',
        leadAuditor: 'الموقع / رئيس المدققين',
        location: 'مكان الإصدار',
        submitBtn: 'إنشاء وتوقيع الشهادة إلكترونياً وبصمة SHA-256',
        successMsg: 'تم إصدار الشهادة بنجاح وتوليد رمز الاستجابة السريعة QR والبصمة المشفرة.',
      },
      logsTitle: 'سجل عمليات التحقق اللحظي من الشهادات',
      backupTitle: 'إدارة البيانات والنسخ الاحتياطي المشفر',
      exportBtn: 'تصدير قاعدة البيانات (ملف JSON مشفر)',
      importBtn: 'استرجاع نسخة احتياطية',
      resetBtn: 'إعادة ضبط البيانات الأولية',
    },
    footer: {
      tagline: 'مكتب دولي للتدقيق، الاستشارات، التأهيل المهني QHSE وإصدار الشهادات للمؤسسات والأفراد.',
      quickLinks: 'روابط سريعة',
      servicesTitle: 'مجالات الخبرة',
      legalTitle: 'الأمان والمطابقة',
      copyright: 'جميع الحقوق محفوظة. نظام تحقق معتمد ومحمي ضد التزوير.',
      confidentiality: 'سياسة الخصوصية',
      terms: 'الشروط القانونية',
      isoStatement: 'تتوافق عمليات التقييم والاعتماد مع المعايير الدولية ISO/IEC 17024 و ISO/IEC 17021.',
    },
  },
};
